module.exports = __webpack_public_path__ + "static/media/perk-solopreneur-2.6ab5d453.jpg";